module.exports = __webpack_public_path__ + "onboarding-pkg-api.fb2e87efbe7702e7faeac1654c02a5ed.hashedasset.svg";